import axios from "axios";
import { API } from "@/lib/config";
import { getAttribution } from "@/hooks/useUtm";
import { getVariant } from "@/hooks/useHeroVariant";

export async function submitLead({ email, source, page }) {
  const attribution = getAttribution();
  const res = await axios.post(`${API}/leads`, {
    email,
    source,
    page,
    variant: getVariant(),
    ...attribution,
  });
  return res.data;
}
